import script from "./popular-products.vue?vue&type=script&setup=true&lang=js"
export * from "./popular-products.vue?vue&type=script&setup=true&lang=js"

import "./popular-products.vue?vue&type=style&index=0&id=e1df1b10&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1df1b10"]])

export default __exports__